import types from 'constants/actionTypes';
import mergeByIds from '../../utils/mergeByIds';
import { combineReducers } from 'redux';
 
const initialState = {
  byId: {},
  checkLockStatus: false,
  error: null,
};
 
// byId reducer
const byId = (state = initialState.byId, { type, payload }) => {
  switch (type) {
    case types.WEBSOCKET_UPDATE_CURRENT_USER:
      const newState = {};
      payload.models.forEach(model => {
        const id = model.id;
        newState[id] = model;
      });
      return newState;
 
    case types.GET_MODELS_VIEWERS_REQUEST_SUCCESS:
    case types.UPDATE_CURRENT_VIEWER_REQUEST_SUCCESS:
  if (!payload?.entities?.modelsViewers) {
    sessionStorage.setItem("No modelsViewers found in payload", payload);
    return state; // Return unchanged state
  }
  return mergeByIds({
    byIdCurrent: state,
    byIdToMerge: payload.entities.modelsViewers,
  });
 
    case types.GET_MODELS_VIEWERS_REQUEST_FAILURE:
    case types.UPDATE_CURRENT_VIEWER_REQUEST_FAILURE:
      return state;
 
    default:
      return state;
  }
};
 
// checkLockStatus reducer
const checkLockStatus = (state = initialState.checkLockStatus, { type }) => {
  switch (type) {
    case types.WEBSOCKET_UPDATE_CURRENT_USER:
      return true;
    case types.RESET_CHECK_LOCK_STATUS:
      return false;
    default:
      return state;
  }
};
 
// error reducer
const error = (state = initialState.error, { type, payload }) => {
  switch (type) {
    case types.GET_MODELS_VIEWERS_REQUEST_FAILURE:
    case types.UPDATE_CURRENT_VIEWER_REQUEST_FAILURE:
      return payload?.error || 'Unknown error occurred.';
 
    case types.GET_MODELS_VIEWERS_REQUEST_SUCCESS:
    case types.UPDATE_CURRENT_VIEWER_REQUEST_SUCCESS:
    case types.WEBSOCKET_UPDATE_CURRENT_USER:
    case types.RESET_CHECK_LOCK_STATUS:
      return null;
 
    default:
      return state;
  }
};
 
export default combineReducers({
  byId,
  checkLockStatus,
  error,
});
